export const COURSE_API = '/api/dashboard/customer/membership/course'
